class ComponentReviewVideo extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      video: "video",
      toggle: "button"
    });
  }

  static get observedAttributes() {
    return ["playing"];
  }

  attributeChangedCallback() {
    if (!this.elements.toggle) {
      return;
    }

    this.elements.toggle.setAttribute("aria-label", this.hasAttribute("playing") ? "Pause video" : "Play video");
  }

  connectedCallback() {
    super.connectedCallback();

    this.querySelector("video > img")?.setAttribute("alt", "");

    if (!this.elements.video || !this.elements.toggle) {
      return;
    }

    this.addDirectEvent("click", this, () => this.togglePause());

    this.pauseOutsideViewport();
  }

  togglePause() {
    if (this.hasAttribute("playing")) {
      this.pause();
    } else {
      this.play();
    }
  }

  play() {
    const video = this.elements.video;

    this.pauseOthers();
    this.setAttribute("playing", "true");
    video.muted = false;

    if (video.readyState === 0) {
      video.removeAttribute("loading");
      video.addEventListener("loadeddata", () => this.start(), { once: true });
      video.load();
      return;
    }

    this.start();
  }

  start() {
    if (!this.hasAttribute("playing")) {
      return;
    }

    this.elements.video.play().catch(() => this.removeAttribute("playing"));
  }

  pause() {
    this.removeAttribute("playing");
    this.elements.video.pause();
    this.elements.video.muted = true;
  }

  pauseOthers() {
    document.querySelectorAll("component-review-video[playing]").forEach(component => {
      if (component !== this) {
        component.pause();
      }
    });
  }

  pauseOutsideViewport() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.pause();
        }
      });
    });

    observer.observe(this);
  }
}

customElements.define("component-review-video", ComponentReviewVideo);
